export default function Marquee({ items, className = "" }) {
  const row = [...items, ...items];
  return (
    <div className={`overflow-hidden py-10 border-y border-zinc-200 bg-bone ${className}`} data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-4xl md:text-6xl font-bold uppercase tracking-tight px-8 text-outline">
              {item}
            </span>
            <span className="w-2 h-2 bg-signal rounded-full shrink-0" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
}
